module.exports = __webpack_public_path__ + "img/zoom-2025.ae32ef24.svg";